export default {
  title: '成为Kilimall卖家',
  question: '您是否已有Kilimall消费者账号？',
  hasAccount: '我已有消费者账号',
  hasAccountDesc: '选择此项，将使用消费者账号登录，新开通的商户将直接绑定至该全局用户账号。',
  noAccount: '我暂无消费者账号',
  noAccountDesc: '选择此项，将为您创建全新的全局用户账号，并同步开通商户角色。',
  oauthStateInvalid: '授权校验失败，请重新授权。',
  oauthCodeMissing: '授权码缺失，请重新授权。'
}
